import React from "react";

const ContactInfo = () => {
  return (
    <section className="information">
      <article>
        <i className="fas fa-envelope"></i>
        <h4>Email</h4>
        <a href="mailto:fatima.abid.zohra@gmail.com">
          fatima.abid.zohra@gmail.com
        </a>
      </article>

      <article>
        <i className="fas fa-phone"></i>
        <h4>Télephone</h4>
        <a href="tel:0033635794348">06 35 79 43 48</a>
      </article>
    </section>
  );
};

export default ContactInfo;
